import { db, auth } from '@/firebase'
import firebase from 'firebase/app'
import axios from 'axios'
import store from '../store'
import moment from 'moment'

// import router from '@/router'
// const loginUrl = 'https://us-central1-videojuego-sh.cloudfunctions.net/loginPlayer'
const studentsWithoutGroupURL = 'https://us-central1-videojuego-sh.cloudfunctions.net/studentsWithoutGroup'
const studentsAssignedURL = 'https://us-central1-videojuego-sh.cloudfunctions.net/studentsAssigned'
const studentsURL = 'https://us-central1-videojuego-sh.cloudfunctions.net/students'
const lastSignInTimeUrl = 'https://us-central1-videojuego-sh.cloudfunctions.net/lastSignInTime'
const studentsByGroupURL = 'https://us-central1-videojuego-sh.cloudfunctions.net/studentsByGroup'

export default {
    async getUserData () {
        try {
            const user = auth.currentUser

            const resDataUser = await firebase
                .firestore()
                .collection('users')
                .doc(user.uid)
                .get()

            // const studentsWithoutGroup = await axios
            //     .post(studentsWithoutGroupURL, {
            //         uid: user.uid,
            //     })

            const studentsAssigned = await axios
                .post(studentsAssignedURL, {
                    uid: user.uid,
                })

            const students = await axios
                .post(studentsURL, {
                    uid: user.uid,
                })

            const st = students.data.students
            st.forEach(async (s, i) => {
                const episode1 = await this.updateQuizzes(s.actions.id)
                const details = await this.getStudent(s.actions.id)
                st[i] = Object.assign(st[i], { episode1 })
                st[i] = Object.assign(st[i], { details })
                st[i].average = await this.getAvg(s.actions.id)
            })

            const assigneds = studentsAssigned.data.students
            assigneds.forEach(async (s, i) => {
                const episode1 = await this.updateQuizzes(s.actions.id)
                const details = await this.getStudent(s.actions.id)
                assigneds[i] = Object.assign(assigneds[i], { episode1 })
                assigneds[i] = Object.assign(assigneds[i], { details })
                assigneds[i].average = await this.getAvg(s.actions.id)
            })

            const self_episode1 = await this.updateQuizzes(user.uid)
            const self_details = await this.getStudent(user.uid)

            let selfStudent = [
                {
                    name : self_details.name,
                    group : 'self',
                    actions: {
                        id: user.uid,
                    },
                    episode1 : self_episode1,
                    details : self_details,
                }
            ]

            const studentsData = {
                //studentsWithoutGroup: studentsWithoutGroup.data,
                studentsAssigned: assigneds,
                students: st,
                self : selfStudent
            }

            this.getNotifications(user.uid)
            return Object.assign(resDataUser.data(), studentsData)
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async getAvg (uid) {
        const getQuizzes = await db.collection('quiz').where('user_id', '==', uid).get()
        // const levels = []
        const helper = {}
        let answers = 0
        let totalCorrect = 0
        let avg = 0
        let count = 0
        getQuizzes.forEach(q => {
            if (q.data().end_time !== null) {
                const key = q.data().level_id
                const level = q.data()
                level.end = new Date(q.data().end_time.seconds * 1000 + q.data().end_time.nanoseconds / 1000000)
                if (!helper[key]) {
                    count++
                    helper[key] = level
                    answers = String(q.data().answers)
                    totalCorrect += answers.split('2').length - 1
                    avg = totalCorrect / count
                } else {
                    if (level.end < helper[key].end) {
                        helper[key] = level
                        answers = String(q.data().answers)
                        totalCorrect += answers.split('2').length - 1
                        avg = totalCorrect / count
                        console.log(q.data().user_id, avg)
                    }
                }
            }
        })
        return avg.toFixed(2)
    },

    async getAdminData () {
        store.commit('SET_LOADING', true)
        try {
            const st = []
            const students = await db.collection('users').where('type', '==', 'student').get()

            students.forEach(async student => {
                const episode1 = await this.updateQuizzes(student.id)
                st.push(episode1)
            })
            store.commit('SET_DATA_USER_ADMIN', st)
            this.getAdminUsers()
        } catch (error) {
            store.commit('SET_LOADING', false)
            console.log(error)
        }
    },

    async getAdminUsers () {
        try {
            const u = []
            let type = ''
            const users = await db.collection('users').where('type', '!=', 'admin').get()
            users.forEach(async user => {
                const licenses = await db.collection('licenses').where('uid', '==', user.id).get()
                const licensesUser = []
                if (licenses.docs) {
                    licenses.forEach(l => {
                        licensesUser.push(l.data())
                    })
                }
                switch (user.data().type) {
                    case 'student':
                        type = 'Estudiante'
                        break
                    case 'tutor':
                        type = 'Profesor'
                        break
                    default:
                        type = 'Padre'
                        break
                }
                u.push(Object.assign({}, {
                    uid: user.id,
                    key: user.id,
                    name: `${user.data().firstname} ${user.data().lastname}`,
                    //name: `${user.data().firstname} ${user.data().lastname}`,
                    type,
                    licensesUser,
                }))
            })
            store.commit('SET_ADMIN_USERS', u)
        } catch (error) {
            store.commit('SET_LOADING', false)
            console.log(error)
        }
    },

    async updateQuizzes (uid) {
        const quizzes = {}
        const levels = {}
        const episode = '01'
        try {
            const getQuizzes = await db.collection('quiz').where('user_id', '==', uid).get()
            /* getQuizzes.docs.map(p => {
                console.log(p.data())
            }) */
            getQuizzes.forEach(q => {
                if (q.data().end_time !== null && q.data().level_id.slice(0, -2) === episode) {
                    const levelId = q.data().level_id
                    const answers = String(q.data().answers)
                    if (levels[levelId] == null) {
                        levels[levelId] = []
                    }
                    const totalCorrect = answers.split('2').length - 1
                    const totalAnswered = 20 - (answers.split('0').length - 1)

                    const addQuiz = Object.assign(q.data(), {
                        totalCorrect,
                        totalAnswered,
                    })

                    levels[levelId].push(addQuiz)

                    levels[levelId].sort(
                        (a, b) =>
                            new Date(a.end_time.toDate()).getTime() -
                            new Date(b.end_time.toDate()).getTime(),
                    )

                    levels[levelId] = levels[levelId].slice(0, 2)
                    quizzes.levelsCompleted = Object.keys(levels).filter(q => q.slice(0, -2) === episode).length

                    if (levels[levelId].length > 0) 
                    {
                        let avgTotalCorrect = 0

                        levels[levelId].totalCorrectEvaluation = []
                        levels[levelId].solveTimeEvaluation = []
                        levels[levelId].storyTimeEvaluation = []

                        levels[levelId].forEach((q, i) => 
                        {
                            levels[levelId].evaluations = i + 1

                            let avgSolveTime = 0
                            let avgStoryTime = 0

                            avgTotalCorrect += q.totalCorrect
                            avgSolveTime += q.solve_time / 20
                            avgStoryTime += q.story_time / q.text_count

                            levels[levelId].totalCorrectEvaluation.push(
                                q.totalCorrect,
                            )
                            levels[levelId].solveTimeEvaluation.push(
                                avgSolveTime,
                            )
                            levels[levelId].storyTimeEvaluation.push(
                                avgStoryTime,
                            )
                        })
                        levels[levelId].avgTotalCorrect = (avgTotalCorrect > 0) ? (avgTotalCorrect / levels[levelId].evaluations) : 0
                        /* levels[levelId].avgSolveTime = (avgSolveTime > 0) ? (avgSolveTime / levels[levelId].evaluations) : 0
                        levels[levelId].avgStoryTime = (avgStoryTime > 0) ? (avgStoryTime / levels[levelId].evaluations) : 0 */
                        // levels[levelId].avgSolveTime = avgSolveTime
                        // levels[levelId].avgStoryTime = avgStoryTime
                    }
                }
            })
        } catch (error) {
            console.log(error)
        }
        const levelsCompleted = quizzes.levelsCompleted
        let levelsTotalCorrect = 0
        let levelsSolveTime = 0
        let levelsStoryTime = 0
        const TotalCorrectEvaluations = []
        const AvgCorrectEvaluations = []
        const TotalLevelsEvaluations = []
        const SolveTimeEvaluations = []
        const AvgSolveTimeEvaluations = []
        const StoryTimeEvaluations = []
        const AvgStoryTimeEvaluations = []
        let correctEv1 = 0
        let correctEv2 = 0
        let avgCorrectEv1 = 0
        let avgCorrectEv2 = 0
        let levelEv1 = 0
        let levelEv2 = 0
        let solveTimeEv1 = 0
        let solveTimeEv2 = 0
        let avgSolveTimeEv1 = 0
        let avgSolveTimeEv2 = 0
        let storyTimeEv1 = 0
        let storyTimeEv2 = 0
        let avgStoryTimeEv1 = 0
        let avgStoryTimeEv2 = 0
        Object.keys(levels).filter(q => q.slice(0, -2) === episode).map(q => {
            levels[q].map((e, i) => {
                if (i === 0) {
                    correctEv1 += parseFloat(levels[q].totalCorrectEvaluation[i])
                    solveTimeEv1 += parseFloat(levels[q].solveTimeEvaluation[i])
                    storyTimeEv1 += parseFloat(levels[q].storyTimeEvaluation[i])
                    TotalCorrectEvaluations[i] = correctEv1
                    SolveTimeEvaluations[i] = solveTimeEv1
                    levelEv1++
                    avgCorrectEv1 = correctEv1 > 0 ? parseFloat(correctEv1 / levelEv1) : 0
                    avgSolveTimeEv1 = solveTimeEv1 > 0 ? parseFloat(solveTimeEv1 / levelEv1) : 0
                    avgStoryTimeEv1 = storyTimeEv1 > 0 ? parseFloat(storyTimeEv1 / levelEv1) : 0
                    TotalLevelsEvaluations[i] = levelEv1
                    AvgCorrectEvaluations[i] = avgCorrectEv1.toFixed(2)
                    AvgSolveTimeEvaluations[i] = avgSolveTimeEv1.toFixed(2)
                    AvgStoryTimeEvaluations[i] = avgStoryTimeEv1.toFixed(2)
                } else {
                    correctEv2 += parseInt(levels[q].totalCorrectEvaluation[i])
                    solveTimeEv2 += parseFloat(levels[q].solveTimeEvaluation[i])
                    storyTimeEv2 += parseFloat(levels[q].storyTimeEvaluation[i])
                    TotalCorrectEvaluations[i] = correctEv2
                    SolveTimeEvaluations[i] = solveTimeEv2.toFixed(2)
                    StoryTimeEvaluations[i] = storyTimeEv2.toFixed(2)
                    levelEv2++
                    avgCorrectEv2 = correctEv2 > 0 ? parseFloat(correctEv2 / levelEv2).toFixed(2) : 0
                    avgSolveTimeEv2 = solveTimeEv2 > 0 ? parseFloat(solveTimeEv2 / levelEv1).toFixed(2) : 0
                    avgStoryTimeEv2 = storyTimeEv2 > 0 ? parseFloat(storyTimeEv2 / levelEv1).toFixed(2) : 0
                    TotalLevelsEvaluations[i] = levelEv2
                    AvgCorrectEvaluations[i] = parseFloat(avgCorrectEv2).toFixed(2)
                    AvgSolveTimeEvaluations[i] = parseFloat(avgSolveTimeEv2).toFixed(2)
                    AvgStoryTimeEvaluations[i] = parseFloat(avgStoryTimeEv2).toFixed(2)
                }
            })
            levelsTotalCorrect += parseFloat(levels[q].avgTotalCorrect / levelsCompleted)
            levelsSolveTime += parseFloat(levels[q].avgSolveTime / levelsCompleted)
            levelsStoryTime += parseFloat(levels[q].avgStoryTime / levelsCompleted)
        })
        quizzes.levelsTotalCorrect = parseFloat(levelsTotalCorrect).toFixed(2)
        quizzes.levelsSolveTime = parseFloat(levelsSolveTime).toFixed(2)
        quizzes.levelsStoryTime = parseFloat(levelsStoryTime).toFixed(2)
        quizzes.TotalCorrectEvaluations = TotalCorrectEvaluations
        quizzes.TotalLevelsEvaluations = TotalLevelsEvaluations
        quizzes.AvgCorrectEvaluations = AvgCorrectEvaluations
        quizzes.SolveTimeEvaluations = SolveTimeEvaluations
        quizzes.StoryTimeEvaluations = StoryTimeEvaluations
        quizzes.AvgSolveTimeEvaluations = AvgSolveTimeEvaluations
        quizzes.AvgStoryTimeEvaluations = AvgStoryTimeEvaluations
        quizzes.levels = levels
        return quizzes
    },
    getNotifications (uid) {
        db.collection('users').doc(uid)
            .onSnapshot(function (doc) {
                if (doc.data().notifications) {
                    store.commit('SET_NOTIFICATIONS', doc.data().notifications)
                } else {
                    store.commit('SET_NOTIFICATIONS', [])
                }
            })
    },

    async agregateLicenseUser (data) {
        try {
            const quantity = data.quantity

            const licenseData = {
                uid: data.uid,
                product_name: data.productName,
                productId: data.productId,
                date: moment().format(),
                order_id: null,
                player_name: '',
                player_uid: '',
            }
            const user = await db.collection('users').doc(data.uid).get()
            const licensesQuantity = user.data().licensesQuantity + quantity
            await db.collection('users').doc(data.uid).update({
                licensesQuantity,
            })
            for (let index = 0; index < quantity; index++) {
                const licenseReference = await db.collection('licenses').doc()
                await licenseReference.set(licenseData)
            }
            return 'ok'
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async setCreateGroup (data) {
        try {
            await firebase
                .firestore()
                .collection('users')
                .doc(data.uid)
                .update({
                    groups: firebase.firestore.FieldValue.arrayUnion(data.groupNew),
                })
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async setEditGroup (data) {
        try {
            await firebase
                .firestore()
                .collection('users')
                .doc(data.uid)
                .update({
                    groups: data.groups,
                })
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async getStudent (uid) {
        try {
            const response = await firebase
                .firestore()
                .collection('users')
                .doc(uid)
                .get()
            const data = response.data()
            const student = {
                user_id : uid,
                firstname : `${data.firstname}`,
                lastname : `${data.lastname}`,
                name: `${data.firstname} ${data.lastname}`,
                //nickname: data.nickname,
                history: data.history,
                levels_history: data.history.episode_1.levels,
                tutor_extra_permission: data.tutor_extra_permission,
            }

            const lastSignInTime = await axios
                .post(lastSignInTimeUrl, {
                    uid,
                })

            return Object.assign(student, lastSignInTime)
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async studentsByGroup (data) {
        try {
            const response = await axios
                .post(studentsByGroupURL, {
                    uid: data.uid,
                    groupId: data.groupId,
                })
            const st = response.data
            st.students.forEach(async (s, i) => {
                const episode1 = await this.updateQuizzes(s.actions.id)
                st.students[i] = Object.assign(st.students[i], { episode1 })
                response.data.students[i].average = await this.getAvg(s.actions.id)
            })
            return response.data
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async updatePermissionTutor (data) {
        try {
            var student = firebase.firestore().collection('users').doc(data.studentId)
            const getStudent = await student.get()
            const tutorExtraPermission = getStudent.data().tutor_extra_permission
            tutorExtraPermission.blockLevels = data.blockLevels
            tutorExtraPermission.viewStatistics = data.viewStatistics

            student.update({
                tutor_extra_permission: tutorExtraPermission,
            })

            return 'Ok'
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

    async getLicense (uid) {
        try {
            const response = await firebase
                .firestore()
                .collection('licenses')
                .where('uid', '==', uid)
                .get()

            const lincenses = []
            response.docs.forEach(l => lincenses.push(Object.assign({ id: l.id }, l.data())))
            return lincenses
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
        }
    },

}
